export default "__VITE_ASSET__By8pxO$N__"